module.exports = require('./_global');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_path.js
// module id = 162
// module chunks = 0